import api from './api';

export const createDesignRequest = ({ subject, body }) =>
  api.post('/admin/member-requests/design', { subject, body }).then(r => r.data.request);

export const listAllRequests = (status) =>
  api.get('/admin/member-requests', { params: status ? { status } : {} }).then(r => r.data.requests);

export const getRequestDetail = (id) =>
  api.get(`/admin/member-requests/${id}`).then(r => r.data);

export const respondToRequest = (id, { body, status }) =>
  api.post(`/admin/member-requests/${id}/responses`, { body, status }).then(r => r.data);

// A short topic Team365 gives a request, e.g. "Sleep help" (2026-09-29). Empty clears it.
export const setRequestTopic = (id, topic) =>
  api.put(`/admin/member-requests/${id}/topic`, { topic }).then(r => r.data.request);

export const updateRequestStatus = (id, status) =>
  api.put(`/admin/member-requests/${id}/status`, { status }).then(r => r.data);
